export const asideWidth = 200
export const veryLargeBreakpoint = 1700
export const mainPadding = 0
export const roofPadding = 0

export const headerHeight = 50
export const footerHeight = 30

export const editBtnWrapper = 45

export const mainMargin = 5
